import React, { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { getConfig } from '@fec/assets/js/utils/config';
import { ErrorBoundary } from 'react-error-boundary';
import MediaLoading from '@fec/frontend-aron/elements/media/MediaLoading/MediaLoading';
import MediaError from '@fec/frontend-aron/elements/media/MediaError/MediaError';

const BasicVideo = lazy(
  () => import('@fec/frontend-aron/modules/media/BasicVideo/BasicVideo'),
);
const BasicAudio = lazy(
  () => import('@fec/frontend-aron/modules/media/BasicAudio/BasicAudio'),
);
const InlineAudio = lazy(
  () => import('@fec/frontend-aron/modules/media/InlineAudio/InlineAudio'),
);
const BasicVideoApp = lazy(
  () => import('@fec/frontend-aron/modules/media/BasicVideoApp/BasicVideoApp'),
);
const BasicAudioApp = lazy(
  () => import('@fec/frontend-aron/modules/media/BasicAudioApp/BasicAudioApp'),
);
const InlineAudioApp = lazy(
  () =>
    import('@fec/frontend-aron/modules/media/InlineAudioApp/InlineAudioApp'),
);
const LivestreamVideo = lazy(
  () =>
    import('@fec/frontend-aron/modules/media/LivestreamVideo/LivestreamVideo'),
);
const LivestreamVideoApp = lazy(
  () =>
    import(
      '@fec/frontend-aron/modules/media/LivestreamVideoApp/LivestreamVideoApp'
    ),
);
import '@fec/frontend/foundation/translations/react_i18n_init';

import './PlayerWidget.scss';

export function init() {
  const config = getConfig();
  const widgetContainer = document.querySelectorAll('.js-player-widget');

  const representation = config.REPRESENTATION ?? 'web';
  const isWebview = representation.includes('webview');

  // Inject our React App into each class
  widgetContainer.forEach((widget) => {
    const asset = JSON.parse(widget.dataset.asset);
    const isTopMediaElement = widget.dataset?.topMediaElement === 'true';

    let PlayerComponent;
    switch (asset.type) {
      case 'video':
        PlayerComponent = isWebview ? BasicVideoApp : BasicVideo;
        break;
      case 'audio':
        if (isTopMediaElement) {
          PlayerComponent = isWebview ? BasicAudioApp : BasicAudio;
        } else {
          PlayerComponent = isWebview ? InlineAudioApp : InlineAudio;
        }
        break;
      case 'livestream':
        PlayerComponent = isWebview ? LivestreamVideoApp : LivestreamVideo;
        break;
    }

    createRoot(widget).render(
      <React.StrictMode>
        <Suspense
          fallback={
            <MediaLoading type={asset.type} noBackground={isTopMediaElement} />
          }>
          <ErrorBoundary fallback={<MediaError />}>
            <PlayerComponent
              asset={asset}
              isTopMediaElement={isTopMediaElement}
            />
          </ErrorBoundary>
        </Suspense>
      </React.StrictMode>,
    );
  });
}
